import NextBtn from "../common/NextBtn";
import PreviousBtn from "../common/PreviousBtn";
import styles from "./CreateMapSetting.module.css";
import MarkerPreView from "./MarkerPreView";
import Marker from "./Marker";
import { Dispatch, SetStateAction, useState } from "react";
import { markerInfoType } from "./CreateMap";
import ContentTitle from "../common/ContentTitle";

interface MarkerSettingProps {
    processIdx: number;
    canProceed: boolean;
    setCanProceed: Dispatch<SetStateAction<boolean>>;
    progressProcess: (n: number) => void;
    sampleData: {
        row1: string[];
        row2: string[];
    };
    optionByCategory: {
        optionByCategory: { [fieldName: string]: string[] };
    };
    markerInfo: markerInfoType;
    markerSettingFn: {
        setMarkerInfo: Dispatch<SetStateAction<markerInfoType>>;
        selectMarkerLabel: (option: number) => void;
    };
}

/**
 * @author cjs
 * @date 2024-09-12 11:21:47
 * @remark 지도만들기 마커 설정 컴포넌트
 * @pram props
 * @props MarkerSettingProps
        processIdx(required) : 지도만들기 화면 순서
        progressProcess(required) : 지도만들기 화면 순서 변경 함수
        sampleData(required) : 마커 설정과 장소 정보 설정에 미리 보여주기 위한 예제 데이터
        optionByCategory(required) : 마커 설정 화면에 카테고리별설정 selectBox 데이터 
        markerInfo(required) : 마커 설정한 데이터
        markerSettingFn(required) : 마커 설정 데이터 변경 함수
    @returns MarkerSetting
 */

function MarkerSetting(props: MarkerSettingProps) {
    return (
        <>
            <div className={styles.wrapPreView}>
                <MarkerPreView markerInfo={props.markerInfo} exampleData={props.sampleData.row2} />
            </div>
            <div className={`${styles.wrap} undraggable`}>
                <div className={styles.container}>
                    <div className={styles.title}>
                        <ContentTitle title="마커설정" />
                    </div>
                    {
                        <Marker
                            canProceed={props.canProceed}
                            sampleData={props.sampleData}
                            optionByCategory={props.optionByCategory}
                            markerInfo={props.markerInfo}
                            markerSettingFn={props.markerSettingFn}
                        />
                    }
                    <div className={styles.footer}>
                        <div className={styles.wrapProgressBtn}>
                            <div className={`${props.processIdx === 0 ? styles.hideBtn : styles.activeBtn}`}>
                                <PreviousBtn progressProcess={props.progressProcess} />
                            </div>
                            <div className={styles.nextBtn}>
                                <NextBtn progressProcess={props.progressProcess} canProceed={props.canProceed} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default MarkerSetting;
